module.exports = __webpack_public_path__ + "img/2.2868e5be.png";